import { Colors } from "@snapchat/snap-design-system";

import { SpecApprovalState } from "../../gql-generated/types";

export const mapApiStatus = (status: SpecApprovalState): { name: string; color: string } => {
    switch (status) {
        case SpecApprovalState.ApprovalStateUnset:
            return { name: "Draft", color: Colors.Gray.V250 };
        case SpecApprovalState.InReview:
            return { name: "In Review", color: Colors.Orange.V100 };
        case SpecApprovalState.Approved:
            return { name: "Approved", color: Colors.Green.V150 };
        case SpecApprovalState.Blocked:
            return { name: "Blocked", color: Colors.Red.V150 };
        default:
            return { name: "_", color: Colors.Gray.V250 };
    }
};
